import { useCallback } from 'react';

export function useRefetchOnMutation(query, mutation) {
  return useCallback(
    (...args) => mutation(...args).then(() => query()),
    [mutation, query]
  );
}
